"use client";
import { IntroVideoSection } from "@/src/api/fetchHomeSections/types";
import { useFindSection } from "@/src/hooks/useFindSection";
import useModal from "@/src/hooks/useModal";
import AnimatedHeader from "@/src/components/AnimatedVideoHeader/AnimatedVideoHeader";
import ContactUs from "@/src/components/ContactUs";
import { HomeSectionProps } from "@/src/types/home-section-props";

const IntroVideo: React.FC<HomeSectionProps> = ({ data }) => {
  const foundSection = useFindSection(data, "intro_video");
  const introVideoSection = foundSection as IntroVideoSection | undefined;

  const {
    isOpen: isContactModalOpen,
    openPopup: openContactModal,
    closePopup: closeContactModal,
  } = useModal();

  if (!introVideoSection) return null;

  const contactButton = introVideoSection.buttons?.find(
    (btn) => btn.acf_fc_layout === "contact_button"
  );

  const linkButton = introVideoSection.buttons?.find(
    (btn) => btn.acf_fc_layout === "link_button"
  );

  return (
    <div className="w-screen h-screen relative">
      {introVideoSection.intro_video?.url && (
        <video
          className="w-full h-full object-cover"
          src={introVideoSection.intro_video.url}
          autoPlay
          loop
          muted
        />
      )}
      <AnimatedHeader
        videoHeader={introVideoSection.video_header || ""}
        videoSubheader={introVideoSection.subheader || ""}
        contactButton={contactButton}
        linkButton={linkButton}
        openContactModal={openContactModal}
      />
      <ContactUs isOpen={isContactModalOpen} onClose={closeContactModal} />{" "}
    </div>
  );
};

export default IntroVideo;
